export const GroupBookingPaymentVariantValues = {
  WINTER: 'winter',
  TOTALLY_SNOW: 'totallysnow',
} as const

export type GroupBookingPaymentVariant = typeof GroupBookingPaymentVariantValues[keyof typeof GroupBookingPaymentVariantValues]
